import api from '@/services/Api';

class RentalProductService {

  // NOTE: Disable manufacturer List and Category List filter.
  // Boomerang just need get all RentalProduct for now.
  // async getRentalProductPaginatedList(page, manufacturerId, categoryList, availabilityStatusList) {
  //   let joinedCategoryList = categoryList.join(',')
  //   let joinedAvailabilityStatusList = availabilityStatusList.join(',')
  //
  //   const response = await api.get(
  //     '/rental/distributor/product/list',
  //       {
  //         params: {
  //           page,
  //           limit: 12,
  //           manufacturer_id: manufacturerId,
  //           category_list: joinedCategoryList,
  //           availability_status_list: joinedAvailabilityStatusList
  //         }
  //       }
  //   )
  //   return response.data
  // }
  async getRentalProductPaginatedList(page, availabilityStatusList) {
    let joinedAvailabilityStatusList = availabilityStatusList.join(',')

    const response = await api.get(
      '/rental/distributor/product/list',
        {
          params: {
            page,
            limit: 12,
            availability_status_list: joinedAvailabilityStatusList
          }
        }
    )
    return response.data
  }

  async getRentalProductDetailById(rentalProductId) {
    const response =
      await api.get('/rental/distributor/product-detail/' + rentalProductId)
    return response.data
  }
}

export default new RentalProductService()
